import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { getCurrencyConfiguration } from "@src/store/slices/organization/selectors/getCurrencyConfiguration";

export const getOrgCurrencyFormat = createSelector(
  getCurrencyConfiguration,
  (configuration) => {
    return new Intl.NumberFormat(configuration?.locale ?? "en-US", {
      style: "currency",
      currency: configuration?.code ?? "USD",
      minimumFractionDigits: 2,
    });
  }
);
